import React from 'react';

const TutorialArrow = ({ direction = 'down', className = '' }) => {
  const rotate = {
    down: 'rotate-180',
    up: 'rotate-0',
    left: '-rotate-90',
    right: 'rotate-90',
  };

  return (
    <div className={`flex flex-col items-center animate-tutorial-bounce ${className}`}>
      <svg
        className={`w-6 h-6 ${rotate[direction]}`}
        viewBox="0 0 24 24"
        fill="none"
        style={{ filter: 'drop-shadow(0 0 9px rgba(245,208,122,0.75))' }}
      >
        <defs>
          <linearGradient id="tutArrowGrad" x1="12" y1="2" x2="12" y2="22"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#FFF0C6" />
            <stop offset="1" stopColor="#D4A052" />
          </linearGradient>
        </defs>
        <path
          d="M12 3.5v15M12 3.5l-5.5 5.5M12 3.5l5.5 5.5"
          stroke="url(#tutArrowGrad)"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default TutorialArrow;
